import { UtensilsCrossed } from "lucide-react";
import PhotoFrame from "./PhotoFrame";

const PREFERENCES = [
  { label: "Vegetarian preferences", value: "Editable on enquiry" },
  { label: "Non-vegetarian preferences", value: "Editable on enquiry" },
  { label: "Children's meals", value: "Editable on enquiry" },
  { label: "Elderly-friendly meals", value: "Editable on enquiry" },
  { label: "Meal timings", value: "Discussed with caretaker" },
  { label: "Ingredient or grocery arrangements", value: "Local store outside gate" },
  { label: "Additional meal charges", value: "Where applicable" },
];

export default function Food({ image }) {
  return (
    <section className="py-24 md:py-32 bg-[#F7F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <PhotoFrame
              image={image}
              placeholderLabel="Home-cooked meal"
              placeholderCaption="Caretaker-assisted dining"
              placeholderIcon={UtensilsCrossed}
              ratio="aspect-[4/5]"
            />
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Food & caretaker</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
              Meals made with the comfort <span className="italic text-[#985F47]">of home.</span>
            </h2>
            <p className="mt-8 text-[#4A4D4A] text-base md:text-lg leading-relaxed max-w-2xl">
              The full-time caretaker can prepare fresh, simple and comforting meals based on guest
              preferences and prior discussion. This makes ChiMano House especially convenient for
              families, elderly guests and longer stays.
            </p>

            <dl className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
              {PREFERENCES.map((p, i) => (
                <div
                  key={p.label}
                  data-testid={`food-pref-${i}`}
                  className="border-b border-[#2C392F]/10 pb-4"
                >
                  <dt className="text-[11px] uppercase tracking-[0.2em] text-[#985F47] mb-1">{p.label}</dt>
                  <dd className="serif text-xl text-[#2C392F]">{p.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
